
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const StatusLabel = ({
  color,
  children,
  className,
}) => (
  <span className={classNames('StatusLabel', color, className)}>
    <span className="text text-uppercase">
      {children}
    </span>
  </span>
);


StatusLabel.propTypes = {
  color: PropTypes.oneOf(['red', 'green', 'yellow', 'blue', 'darkgrey', 'lightgrey']),
  className: PropTypes.string,
  children: PropTypes.any,
};

StatusLabel.defaultProps = {
  color: 'lightgrey',
  className: null,
  children: null,
};

export default StatusLabel;
